'use strict'

import CampaignsList from '@/pages/Campaign/CampaignList.vue'
import ifAuthenticated from '@/router/middleware'

export default [
  {
    path: '/:site/campaigns',
    name: 'campaigns',
    component: CampaignsList,
    beforeEnter: ifAuthenticated
  }
]



// WEBPACK FOOTER //
// ./src/router/domains/campaign.js